<template>
  <v-navigation-drawer
    fixed
    right
    temporary
    permanent
    flaoting
    :width="width"
    :class="secondaryDrawer ? 'secondary-drawer' : ''"
  >
    <v-btn title="Close" @click="cancel()" text fab small>
      <v-icon dark>$close</v-icon>
    </v-btn>
    <ValidationObserver ref="validator">
      <transition name="component-fade" mode="out-in">
        <component
          :request="request"
          :is="component"
          :hasProject="Boolean(this.project && this.project.id)"
        />
      </transition>
    </ValidationObserver>
    <template v-slot:append>
      <div class="px-7 px-md-16 py-5 py-md-12">
        <v-btn block large class="mb-4" @click="back()">
          {{ step === 1 ? 'Cancel' : 'Back' }}
        </v-btn>
        <v-btn
          block
          large
          class="primary"
          @click="next()"
          :disabled="request.submitting || (step === 3 && request.amount < 1)"
          :loading="request.submitting"
        >
          {{ step === 3 ? 'Payout' : 'Proceed' }}
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import PayoutRequest from '@request/PayoutRequest';
import { mapState } from 'vuex';
export default {
  name: 'Payout',
  components: {
    SelectProject: () => import('@components/_payouts/SelectProject'),
    SelectAmount: () => import('@components/_payouts/SelectAmount'),
    ConfirmPayout: () => import('@components/_payouts/ConfirmPayout'),
  },
  props: {
    secondaryDrawer: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
      default: () => {},
    },
    width: {
      type: [String, Number],
      default: 500,
    },
  },
  data() {
    return {
      step: this.project && this.project.id ? 2 : 1,
      request: new PayoutRequest(this.$refs, {
        project: { ...this.project },
        project_id: this.project ? this.project.id || '' : '',
        percentage: 50,
      }),
    };
  },
  computed: {
    component() {
      switch (this.step) {
        case 3:
          return 'ConfirmPayout';
        case 2:
          return 'SelectAmount';
        default:
          return 'SelectProject';
      }
    },
    ...mapState('auth', {
      user: 'user',
    }),
  },
  methods: {
    cancel() {
      this.$emit('exit');
    },
    async submit() {
      let response = await this.request.submit();
      if (response) {
        await this.$store.dispatch(
          'auth/changeBalance',
          0 - this.request.amount
        );
        this.cancel();
      }
    },
    async back() {
      if (this.step === 1) {
        this.cancel();
        return;
      }
      if (await this.request.validate()) {
        this.step > 1 && this.step--;
      }
    },
    async next() {
      if (await this.request.validate()) {
        if (this.step < 3) {
          this.step++;
        } else {
          this.submit();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
